import { connect } from 'react-redux';
import Assessment from './Assessment';
import timeDepositActions from '../../store/actions/timeDeposit.action';
import googleAnalytics from '../../store/actions/googleAnalytics.action';

const mapStateToProps = state => ({
  newTimeDeposit: state.simulation.newTimeDeposit,
  rating: state.simulation.rating,
  comment:  state.simulation.comment
});

const mapDispatchToProps = dispatch => {
    return {
      cleanSimulation: () => {
        dispatch(timeDepositActions.cleanSimulation());
      },
      setRating: (rating) => {
        dispatch(timeDepositActions.setRating(rating));
      },
      setCommentAssesment: (comment) => {
        dispatch(timeDepositActions.setCommentAssesment(comment));
      },
      googleAnalytics: (params) => {
        googleAnalytics.registerGoogleAnalytics(params);
      }
    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Assessment);
